import Vue from 'vue'
import Vant from 'vant';
import './assets/reset.less';
import App from './App.vue'
import router from './router'
import store from './store'
import "amfe-flexible";

import api from './api';
window.api = Vue.prototype.api = api;

import './assets/app.less';

Vue.use(Vant);
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
